import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/invoiceIssueInfo', request, cancelToken)
}

export {get}
